import { formatDifferenceInHoursAndMinutes } from '@backoffice-frontend/common'
import { Subtitle2 } from '@backoffice-frontend/patterns'
import { ClockIcon } from '@moia-dev/pace-icons'
import { Icon } from '@moia-dev/pace-web'

export const ETALabel = ({ arrivalTime }: { arrivalTime: Date }) => (
  <div
    css={theme => ({
      background: theme.semantic.ColorSurfaceDefault,
      borderRadius: 16,
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0.5, 1),
      gap: theme.spacing(0.5),
      boxShadow:
        '0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 4px 0px rgba(0, 0, 0, 0.20), 0px 1px 1px 0px rgba(0, 0, 0, 0.25)',
    })}
  >
    <Icon size={20}>
      <ClockIcon />
    </Icon>
    <Subtitle2>
      {formatDifferenceInHoursAndMinutes(arrivalTime, new Date(), true)}
    </Subtitle2>
  </div>
)
